import { render, staticRenderFns } from "./order_b2b.vue?vue&type=template&id=6ae3ffc6&scoped=true"
import script from "./order_b2b.vue?vue&type=script&lang=js"
export * from "./order_b2b.vue?vue&type=script&lang=js"
import style0 from "./order_b2b.vue?vue&type=style&index=0&id=6ae3ffc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae3ffc6",
  null
  
)

export default component.exports